import React, { useEffect, useState } from 'react';
export function PromoBanner() {
  const dias = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
  const nombreDia = dias[new Date().getDay()];
  const [tiempo, setTiempo] = useState(15 * 60);
  // Fix body padding so content isn't hidden under the fixed banner
  useEffect(() => {
    const updatePadding = () => {
      document.body.style.paddingTop = window.innerWidth >= 768 ? '82px' : '74px';
    };
    updatePadding();
    window.addEventListener('resize', updatePadding);
    return () => {
      window.removeEventListener('resize', updatePadding);
      document.body.style.paddingTop = '';
    };
  }, []);
  // Countdown timer
  useEffect(() => {
    const intervalo = setInterval(() => {
      setTiempo(t => {
        if (t <= 0) {
          clearInterval(intervalo);
          return 0;
        }
        return t - 1;
      });
    }, 1000);
    return () => clearInterval(intervalo);
  }, []);
  const minutos = String(Math.floor(tiempo / 60)).padStart(2, '0');
  const segundos = String(tiempo % 60).padStart(2, '0');
  return <div className="w-full text-center" style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    background: 'linear-gradient(180deg, #065f5b, #0f766e)',
    padding: '9px 12px 10px 12px',
    zIndex: 9999,
    lineHeight: 1.15
  }} data-id="element-49">
      <p className="font-semibold md:text-[15px]" style={{
      fontSize: '13px',
      color: '#a7f3d0',
      marginBottom: '4px'
    }} dangerouslySetInnerHTML={{
      __html: `🔥 <strong>Oferta especial HOY ${nombreDia}</strong>`
    }} data-id="element-50" />
      <p className="md:text-[13px]" style={{
      fontSize: '12px',
      color: '#d1fae5',
      marginBottom: '8px'
    }} data-id="element-51">
        Termina en{' '}
        <span style={{
        fontWeight: 700
      }} data-id="element-52">
          {minutos}:{segundos}
        </span>
      </p>
      <a href="https://infoliar.com/cart/56888491966796:1" className="inline-block no-underline md:text-[15px] md:px-[28px] md:py-[10px]" style={{
      background: 'white',
      color: '#065f5b',
      fontWeight: 800,
      fontSize: '13px',
      padding: '8px 22px',
      borderRadius: '50px',
      textDecoration: 'none',
      animation: 'breathing 2.4s infinite ease-in-out'
    }} data-id="element-53">
        QUIERO ACCEDER AHORA
      </a>
    </div>;
}